import { AxiosResponse } from 'axios';
import Apis from '../apis';

export enum PerfilConfig {
  NENHUM = 0,
  PUBLICO = 1,
  NAO_SELECIONAVEL = 2,
  NAO_EDITAVEL = 4,
  GRUPO_USUARIO = 8,
}

export type PerfilUsuario = {
  usuario: { uuid: string; nome: string };
};

export type PermissaoDTO = {
  uuid: string;
  sigla: string;
  descricao: string;
};

export type PerfilPermissaoDTO = {
  permissao: PermissaoDTO;
};

export type PerfilDTO = {
  uuid: string;
  nome: string;
  descricao: string;
  usuarios: PerfilUsuario[];
  organizacao: { uuid?: string };
  aplicacao: { uuid?: string; sigla: string };
  permissoes: PerfilPermissaoDTO[];
  configuracoes: number;
};

export type OrganizacaoDTO = {
  uuid?: string;
  nome: string;
  tipoDocumento: string;
  documento: string;
  telefone: string;
  perfis?: PerfilDTO[];
};

export enum UsuarioLoginTipo {
  EMAIL = 'email',
  SMS = 'sms',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
}
export type UserInfoLogin = {
  tipo: UsuarioLoginTipo;
  nomeusuario: string;
  verificadoEm: Date | number;
  valido: boolean;
};
export type UserInfo = {
  uuid?: string;
  nome: string;
  logins: Array<UserInfoLogin>;
};

export type PerfilConsultaDTO = {
  nome?: string;
  populate?: string[];
  limit?: number;
  offset?: number;
  order_by?: string[];
};

export type PerfilIniciarDTO = {
  organizacao: string;
  aplicacaoSigla: string;
};

//export type
type TokenInfo = { aplicacaoName?: string; scope: string; userAgent: string };
export type AuthTokenInfo = { uuid?: string; userAgent: string; criadoEm: string; expiraEm: string; atual?: boolean; tokens: Array<TokenInfo> };
export type TokenPermanent = { uuid?: string; nome: string; scope: string; accessToken?: string };

export class MeDataSource {
  async me(): Promise<AxiosResponse<UserInfo>> {
    return await Apis.ApiIAM.get('/me');
  }
  async alterarNome(nome: string): Promise<AxiosResponse<{ nome: string }>> {
    return await Apis.ApiIAM.post('/me/nome', { nome });
  }
  async alterarEmail(nomeusuario: string): Promise<AxiosResponse<{ nomeusuario: string }>> {
    return await Apis.ApiIAM.post('/me/email', { nomeusuario });
  }
  async removerFacebook(): Promise<AxiosResponse<{ nome: string }>> {
    return await Apis.ApiIAM.delete('/me/removerFacebook');
  }
  async removerGoogle(): Promise<AxiosResponse<{ nomeusuario: string }>> {
    return await Apis.ApiIAM.delete('/me/removerGoogle');
  }
}

export class UsuarioDataSource {
  async findAll(params: { nome: string }): Promise<AxiosResponse<UserInfo[]>> {
    return await Apis.ApiIAM.get(`/usuario`, { params });
  }
}

export class OrganizacaoDataSource {
  async findAll(): Promise<AxiosResponse<OrganizacaoDTO[]>> {
    return await Apis.ApiIAM.get(`/organizacao`);
  }

  async findById(uuid: string): Promise<AxiosResponse<OrganizacaoDTO>> {
    return await Apis.ApiIAM.get(`/organizacao/${uuid}`);
  }

  async criar(organizacao: OrganizacaoDTO): Promise<AxiosResponse<OrganizacaoDTO>> {
    return await Apis.ApiIAM.post(`/organizacao`, organizacao);
  }

  async deletar(uuid: string): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.delete(`/organizacao/${uuid}`);
  }
  async adicionarUsuario(uuid: string, body: { perfil: string; usuario: string }): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.post(`/organizacao/${uuid}/adicionarusuario`, body);
  }

  async removerUsuario(uuid: string, body: { perfil: string; usuario: string }): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.delete(`/organizacao/${uuid}/removerusuario`, { params: body });
  }

  async adicionarProprietario(uuid: string, body: { usuario: string }): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.post(`/organizacao/${uuid}/adicionarproprietario`, body);
  }

  async removerProprietario(uuid: string, body: { usuario: string }): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.delete(`/organizacao/${uuid}/removerproprietario`, { params: body });
  }
}

export class PerfilDataSource {
  async findAll(params?: PerfilConsultaDTO): Promise<AxiosResponse<any[]>> {
    return await Apis.ApiIAM.get(`/perfil`, { params });
  }

  async iniciar(body: PerfilIniciarDTO): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.post(`/perfil/iniciar`, body);
  }

  async criar(perfil?: Partial<PerfilDTO>): Promise<AxiosResponse<PerfilDTO>> {
    return await Apis.ApiIAM.post(`/perfil`, perfil);
  }

  async deletar(uuid: string): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.delete(`/perfil/${uuid}`);
  }
}

export class TokenDataSource {
  async findAll(): Promise<AxiosResponse<AuthTokenInfo[]>> {
    return await Apis.ApiIAM.get(`/token`);
  }
  async findActive(): Promise<AxiosResponse<AuthTokenInfo[]>> {
    return await Apis.ApiIAM.get(`/token/active`);
  }
  async findPermanent(): Promise<AxiosResponse<TokenPermanent[]>> {
    return await Apis.ApiIAM.get(`/token/permanent`);
  }
  async createOrEditPermanent(token: TokenPermanent): Promise<AxiosResponse<TokenPermanent>> {
    return await Apis.ApiIAM.post(`/token/permanent`, token);
  }
  async disable(tokenUuid: string): Promise<AxiosResponse<void>> {
    return await Apis.ApiIAM.delete(`/token/${tokenUuid}`, {
      params: {
        uuid: tokenUuid,
      },
    });
  }
}
